import withAdminLayout from "components/HoC/withAdminLayout";
import PreApprovedAdmin from "components/home/PreApprovedAdmin";
import AllDocumentPage from "pages/admin/smart-visa/AllDocumentPage";
import AllDocumentPagePreApprove from "pages/admin/smart-visa/AllDocumentPagePreApprove";
import AppointmentDetailPage from "pages/admin/smart-visa/AppointmentDetailPage";
import AppointmentPage from "pages/admin/smart-visa/AppointmentPage";
import CancelDetailPage from "pages/admin/smart-visa/CancelDetailPage";
import ConsiderationResult from "pages/admin/smart-visa/ConsiderationResult";
import DocumentDetailPage from "pages/admin/smart-visa/DocumentDetailPage";
import StatusReportDetailPage from "pages/admin/smart-visa/StatusReportDetailPage";
import ViewReasonDetail from "pages/admin/smart-visa/ViewReasonDetail";
import ViewReasonDirectorDetail from "pages/admin/smart-visa/ViewReasonDirectorDetail";
import { useTranslation } from "react-i18next";
import { Route, Switch } from "react-router-dom";

function SmartVisaPage() {
  const { t, i18n } = useTranslation();

  return (
    <Switch>
      <Route path="/admin/smart-visa/all-documents">
        <AllDocumentPage />
      </Route>
      <Route path="/admin/smart-visa/preapprovelist">
        <AllDocumentPagePreApprove />
      </Route>
      <Route path="/admin/smart-visa/issuance-appointment">
        <AppointmentPage />
      </Route>
      <Route path="/admin/smart-visa/consideration-result">
        <ConsiderationResult />
      </Route>
      <Route path="/admin/smart-visa/document/:draftId">
        <DocumentDetailPage />
      </Route>
      <Route path="/admin/smart-visa/preapprove/:draftId">
        <PreApprovedAdmin />
      </Route>

      <Route path="/admin/smart-visa/view-reason/:draftId">
        <ViewReasonDetail />
      </Route>
      <Route path="/admin/smart-visa/view-reason-director/:draftId">
        <ViewReasonDirectorDetail />
      </Route>

      <Route path="/admin/smart-visa/cancel-visa/:personal">
        <CancelDetailPage />
      </Route>
      <Route path="/admin/smart-visa/status-report/:personal">
        <StatusReportDetailPage />
      </Route>

      <Route path="/admin/smart-visa/appointment/:draftId">
        <AppointmentDetailPage />
      </Route>
    </Switch>
  );
}

export default withAdminLayout(SmartVisaPage);
